import React, { ReactNode, VFC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { OverridableComponent } from '@material-ui/core/OverridableComponent';
import { SvgIconTypeMap } from '@material-ui/core/SvgIcon';

interface Props {
  linkProps: {
    href: string;
    target?: string;
    rel?: string;
    'data-gtm'?: string;
  };
  Icon?: OverridableComponent<SvgIconTypeMap<{}, 'svg'>>;
  children: ReactNode;
}
const MoreSeeLink: VFC<Props> = ({
  linkProps,
  Icon = KeyboardArrowRightIcon,
  children,
}: Props) => {
  const classes = useStyles();
  return (
    <Link {...linkProps} classes={classes}>
      <span>{children}</span>
      <Icon fontSize="small" />
    </Link>
  );
};

export default MoreSeeLink;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    [theme.breakpoints.up('sm')]: {
      justifyContent: 'flex-end',
    },
  },
}));
